import { coerceArray } from "@angular/cdk/coercion";
import { getRouterSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";

import { isArray } from "@microsoft/applicationinsights-core-js";

import { LogicalPage, NodeId, OrganizationId, PublicationType } from "src/core/backend/controllers";

interface State {
  router: RouterReducerState<any>;
}

export interface NodeIdAndPage {
  nodeId: NodeId;
  pageNumber?: LogicalPage;
}

export namespace fromRouter {
  export const selectRouter = createFeatureSelector<State, RouterReducerState<any>>("router");

  export const {
    selectCurrentRoute, // select the current route
    selectQueryParams, // select the current route query params
    selectQueryParam, // factory function to select a query param
    selectRouteParams, // select the current route params
    selectRouteParam, // factory function to select a route param
    selectRouteData, // select the current route data
    selectUrl, // select the current url
  } = getRouterSelectors(selectRouter);

  export const selectNodeId = selectRouteParam("nodeId") as MemoizedSelector<State, NodeId | undefined>;
  export const selectPubType = selectRouteParam("nodeId") as MemoizedSelector<State, PublicationType | undefined>;
  export const selectOrgId = selectRouteParam("orgId") as MemoizedSelector<State, OrganizationId | undefined>;

  export const selectPageNumber = createSelector(selectQueryParam("page"), (page) => {
    if (page == null) return;
    const n = parseInt(isArray(page) ? page[0] : page);
    return Number.isNaN(n) ? undefined : (n as LogicalPage);
  });
  export const selectSearchQuery = createSelector(selectQueryParam("search"), (term) => coerceArray(term).join(" "));

  export const selectDocNodePage = createSelector(
    selectNodeId,
    selectPageNumber,
    //
    (nodeId, pageNumber): NodeIdAndPage | undefined => (nodeId == null ? undefined : { nodeId, pageNumber })
  );
}
